import { cva } from 'class-variance-authority';

const selectVariants = cva(
    'flex justify-between items-center w-full text-left text-dark-blue rounded-md border border-gray-200 bg-white px-3.5 shadow-sm transition-all focus-visible:outline-none focus-visible:ring-2 ring-primary/20 focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50 md:text-sm gap-2 focus:border-primary focus:ring-2 focus:ring-primary/20',
    {
        variants: {
            size: {
                normal: 'h-11',
                small: 'h-8 text-xs',
            },
            status: {
                error: 'border-danger',
                highlight:
                    'border-warning ring-2 border-warning focus-visible:ring-2 ring-warning/20 focus-visible:border-warning',
                default: '',
            },
        },
        defaultVariants: {
            size: 'normal',
            status: 'default',
        },
    },
);

export default selectVariants;
